import { Files } from '../../lib/constants/files'
import { TripFolder } from '../../lib/types/models/trip-folder/trip-folder'
import { TripFolderDocumentInput } from '../../lib/types/models/trip-folder/trip-folder-input'
import { IdInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function createTripFolderDocument(input: IdInput<TripFolderDocumentInput>) {
  const { id, ...rest } = input

  const uploadedFile = await uploadFile(Files.TRIP_FOLDER_DOCUMENT, rest.document)
  if (!uploadedFile) throw new Error('Failed to upload file')

  rest.document = uploadedFile

  return restApiClient
    .url(constructApiUrl(API.tripFolder.createDocument.url, { id }))
    .post<TripFolder, TripFolderDocumentInput>(rest)
}
